import { F32 } from '../engine/typed-arrays.js';
import { resolveAccessor } from './gltf-parser.js';

const feature = {
  id: "_morph",
  async applyMesh(meshData, mesh, ctx) {
    const primitive = meshData._primitive;
    const targets = primitive.targets;
    if (!targets || targets.length === 0) {
      return;
    }
    const { _json: json, _binChunk: binChunk } = ctx;
    const morphTargets = [];
    for (const target of targets) {
      const posAcc = target.POSITION !== void 0 ? resolveAccessor(json, binChunk, target.POSITION) : null;
      const normAcc = target.NORMAL !== void 0 ? resolveAccessor(json, binChunk, target.NORMAL) : null;
      morphTargets.push({
        positions: posAcc ? posAcc._data : new F32(meshData._vertexCount * 3),
        normals: normAcc ? normAcc._data : null
      });
    }
    const parentMesh = json.meshes[json.nodes[meshData._nodeIndex].mesh];
    const morphWeights = parentMesh.weights ?? new Array(targets.length).fill(0);
    const { createMorphTargets } = await import('../morph/create-morph-targets.js');
    mesh.morphTargets = createMorphTargets(ctx._engine, morphTargets, meshData._vertexCount, morphWeights);
  }
};

export { feature as default };
//# sourceMappingURL=gltf-feature-morph.js.map
